import {AppState} from '../../index';
import {createSelector} from 'reselect';
import {ProductResponsePayload} from '../../../shared/models/api/productResponsePayload';

export const productsListSelector = () =>
  createSelector(
    (state: AppState) => state.products.list,
    (items) => items,
  );

export const productsByIdSelector = (id: number) =>
  createSelector(
    (state: AppState) => state.products.list?.find((item) => item.id === id),
    (item) => item as ProductResponsePayload,
  );

export const productCategoriesSelector = () =>
  createSelector(
    (state: AppState) => state.products.listProductCategories,
    (item) => item,
  );

export const productAcceptorsSelector = () =>
  createSelector(
    (state: AppState) => state.products.listProductAcceptors,
    (item) => item,
  );

export const productDetailedSelector = () =>
  createSelector(
    (state: AppState) => state.products.detailedProduct,
    (item) => item,
  );
